"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralApi = void 0;
var api_client_1 = __importDefault(require("../api-client"));
var referral_constants_1 = require("./referral.constants");
var ReferralApi = /** @class */ (function () {
    function ReferralApi() {
    }
    ReferralApi.createReferral = function (payload) {
        return api_client_1.default.post(referral_constants_1.REFERRAL_API_URLS.CREATE_REFERRAL_INFO, payload);
    };
    ReferralApi.fetchReferrals = function (payload) {
        return api_client_1.default.post(referral_constants_1.REFERRAL_API_URLS.GET_REFERRAL_ALL, payload);
    };
    ReferralApi.fetchInfluencerReferrals = function (payload) {
        return api_client_1.default.post(referral_constants_1.REFERRAL_API_URLS.GET_INFLUENCER_REFERRALS, payload);
    };
    ReferralApi.fetchTransactions = function (payload) {
        return api_client_1.default.post(referral_constants_1.REFERRAL_API_URLS.GET_TRANSACTIONS, payload);
    };
    ReferralApi.registerReferralLink = function (payload) {
        return api_client_1.default.post(referral_constants_1.REFERRAL_API_URLS.REGISTER_REFERRAL, payload);
    };
    ReferralApi.changeAffiliateStatus = function (payload) {
        return api_client_1.default.post(referral_constants_1.REFERRAL_API_URLS.CHANGE_REFERRAL_STATUS, payload);
    };
    ReferralApi.createOrder = function (payload) {
        return api_client_1.default.post(referral_constants_1.REFERRAL_API_URLS.CREATE_ORDER, payload);
    };
    ReferralApi.updateOrder = function (payload) {
        return api_client_1.default.post(referral_constants_1.REFERRAL_API_URLS.UPDATE_ORDER, payload);
    };
    ReferralApi.downloadCSV = function (payload) {
        return api_client_1.default.post(referral_constants_1.REFERRAL_API_URLS.DOWNLOAD_CSV, payload);
    };
    ReferralApi.fetchUsers = function (payload) {
        return api_client_1.default.post(referral_constants_1.REFERRAL_API_URLS.FETCH_USERS, payload);
    };
    return ReferralApi;
}());
exports.ReferralApi = ReferralApi;
